import { useEffect } from 'react';
import { useState } from 'react';
import './style.scss';

const Toggle = ({ initialValue, onChange, key, overrideState, disabled, initalTrigger }) => {
  const [enabled, setEnabled] = useState(!!initialValue);

  useEffect(() => {
    if (typeof overrideState === 'boolean') {
      setEnabled(overrideState);
    }
  }, [overrideState]);

  useEffect(() => {
    if (onChange && initalTrigger) {
      onChange(enabled);
    }
    // eslint-disable-next-line
  }, [enabled]);

  return (
    <div className={'input-toggle'} style={{ opacity: disabled ? 0.5 : 1, pointerEvents: disabled ? 'none' : 'auto' }}
      onClick={(e) => {
        if (!initalTrigger) {
          setEnabled(!enabled);
          if (onChange) {
            onChange(!enabled);
          }
        }
      }}
    
    >
      <input
        readOnly
        type={'checkbox'}
        name={'moduleState'}
        checked={enabled}
        disabled={disabled}
      />
      <p className={'switch media-label'} onClick={(e) => setEnabled(!enabled)}>
        Enabled
      </p>
    </div>
  );
};

export default Toggle;
